import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchMeetupsdtlbannersec } from "../services/Meetupsdtlbannersec";
import { API_BASE } from "../api/apiConfig";

const Meetupsdtlfreesec = () => {
  const { city } = useParams();
  const [meetup, setMeetup] = useState(null);
  const [loading, setLoading] = useState(true);

  const [activeTab, setActiveTab] = useState('details');

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchMeetupsdtlbannersec(decodeURIComponent(city));

      if (res?.status && res?.data?.length > 0) {
        setMeetup(res.data[0]); // first meetup of city
      }
      setLoading(false);
    };

    loadBanner();
  }, [city]);

  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!meetup) return <p className="text-center py-10">No meetup found</p>;

  return (
      
      <div className="md:col-span-1">
      <div className="sticky top-24 rounded-xl border border-slate-200 bg-white p-6 shadow-md">
        {/* Join Info */}
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-baseline gap-1">
            <span className="text-3xl font-bold text-primary">Free</span>
          </div>
          <div className="flex items-center gap-1 bg-slate-100 px-3 py-1.5 rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="lucide lucide-users h-4 w-4 text-primary"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx={9} cy={7} r={4} />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            <span className="text-sm font-medium text-slate-700">
              {meetup.spots} spots
            </span>
          </div>
        </div>
        {/* Join Buttons */}
        <div className="mb-8 space-y-3">
          <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 px-4 py-2 w-full bg-primary text-white hover:bg-primary/90 h-12 text-base font-medium shadow-sm transition-all duration-300 hover:shadow-md hover:scale-[1.02]">
            Join This Meetup
          </button>
          <div className="flex gap-2">
            <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border bg-background hover:text-accent-foreground h-10 px-4 py-2 flex-1 border-primary/30 text-primary hover:bg-primary/10 transition-all duration-300 hover:scale-[1.02]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="lucide lucide-bookmark mr-2 h-4 w-4"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" />
              </svg>
              Save
            </button>
            <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border bg-background hover:text-accent-foreground h-10 px-4 py-2 flex-1 border-primary/30 text-primary hover:bg-primary/10 transition-all duration-300 hover:scale-[1.02]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="lucide lucide-share2 mr-2 h-4 w-4"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
              >
                <circle cx={18} cy={5} r={3} />
                <circle cx={6} cy={12} r={3} />
                <circle cx={18} cy={19} r={3} />
                <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
                <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
              </svg>
              Share
            </button>
          </div>
        </div>
        {/* Attendees */}
        <div className="space-y-4 rounded-lg bg-slate-50 p-5 border border-slate-100">
          <h3 className="font-medium text-slate-800">Current Attendees</h3>
          <div className="flex flex-wrap -space-x-3">
            <div
              className="h-8 w-8 rounded-full border-2 border-white bg-cover bg-center"
              style={{ backgroundImage: 'url("/member-1.jpg")' }}
            />
            <div
              className="h-8 w-8 rounded-full border-2 border-white bg-cover bg-center"
              style={{ backgroundImage: 'url("/member-2.jpg")' }}
            />
            <div
              className="h-8 w-8 rounded-full border-2 border-white bg-cover bg-center"
              style={{ backgroundImage: 'url("/member-3.jpg")' }}
            />
            <div
              className="h-8 w-8 rounded-full border-2 border-white bg-cover bg-center"
              style={{ backgroundImage: 'url("/member-4.jpg")' }}
            />
            <div
              className="h-8 w-8 rounded-full border-2 border-white bg-cover bg-center"
              style={{ backgroundImage: 'url("/member-5.jpg")' }}
            />
            <div
              className="h-8 w-8 rounded-full border-2 border-white bg-cover bg-center"
              style={{ backgroundImage: 'url("/member-1.jpg")' }}
            />
            <div
              className="h-8 w-8 rounded-full border-2 border-white bg-cover bg-center"
              style={{ backgroundImage: 'url("/member-2.jpg")' }}
            />
            <div
              className="h-8 w-8 rounded-full border-2 border-white bg-cover bg-center"
              style={{ backgroundImage: 'url("/member-3.jpg")' }}
            />
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-white bg-primary text-xs font-medium text-white">
              +16
            </div>
          </div>
          <p className="text-sm text-slate-600">
            Join 24 travelers for this experience
          </p>
        </div>
        {/* Questions / FAQs */}
        <div className="mt-6 rounded-lg bg-primary/5 p-5 border border-primary/10">
          <div className="mb-3 flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="lucide lucide-message-circle h-5 w-5 text-primary"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
            </svg>
            <h3 className="font-medium text-slate-800">Have a question?</h3>
          </div>
          <p className="mb-4 text-sm text-slate-600">
            Contact the host or check the FAQs section for more information
            about this meetup.
          </p>
          <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border bg-background hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 text-primary hover:bg-primary/10">
            View FAQs
          </button>
        </div>
      </div>
    </div>
 
  );
};

export default Meetupsdtlfreesec;
